module.exports = __webpack_public_path__ + "img/2010 winteressen 022.5db14bff.jpg";